/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBudgetAlertTrigger extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBudgetAlertTrigger");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBudgetAlertTrigger.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBudgetAlertTrigger>): BackgroundJobPayloadForBudgetAlertTrigger {
        let obj = Object.assign(new BackgroundJobPayloadForBudgetAlertTrigger(), model);
        BackgroundJobPayloadForBudgetAlertTrigger.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBudgetAlertTrigger>): BackgroundJobPayloadForBudgetAlertTrigger {
        if (!model) return null;
        return BackgroundJobPayloadForBudgetAlertTrigger.newInstance(<BackgroundJobPayloadForBudgetAlertTrigger> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBudgetAlertTrigger) {
        if (!obj) return;

        models.BackgroundJobPayloadForBudgetAlertTrigger.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBudgetAlertTrigger): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBudgetAlertTrigger.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.retries_remaining === undefined) {
            this.retries_remaining = 0;
        }
    }

    /**
     * Id of BUDGET_ALERT_TRIGGER_TRANSACTION_DETAILS document
     */
    budget_alert_trigger_id: string;

    /**
     * number of retries remaining
     */
    retries_remaining: number;

}
